// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()
const context = require.context('controllers', true, /_controller\.js$/)
const contextViewComponents = require.context("../../components", true, /_controller\.js$/)
application.load(definitionsFromContext(context).concat(
  definitionsFromContext(contextViewComponents)
))

import toastr from 'toastr'
toastr.options = {
  closeButton: true,
  timeOut: 6000,
  fadeOut: 6000,
  preventDuplicates: true
}
